import * as React from "react";

function SvgHigh(props) {
  return <svg viewBox="0 0 7 6" fill="none" width="1em" height="1em" {...props}><g clipPath="url(#high_svg__clip0_13003_1790)"><rect y={-0.001} width={6.003} height={6.002} rx={3.001} fill="#1FCD75" /></g><defs><clipPath id="high_svg__clip0_13003_1790" /></defs></svg>;
}

export default SvgHigh;